<template>
    <div>
        <notification-modal :vuexStore="vuexStore" :firstAction="firstAction" :firstActionText="firstActionText" :secondAction="secondAction" :secondActionText="secondActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            vuexStore: 'vendorComplianceDetails',
            messageTitle: 'Delete File',
            message:  'Are you sure you want to delete this file?',
            notificationType: 'warning',
            firstAction: 'deleteFile',
            firstActionText: 'Yes',
            secondAction: 'close',
            secondActionText: 'No, go back',
            resetVariable: 'showDeleteVendorComplianceDetailConfirm'
        }
    },
}
</script>